// extracted by mini-css-extract-plugin
export default {"header":"ClientVariables_header__EiHOJ"};